<template>
  <div id="redirect-layout" :class="[needBlurBackground ? 'modalBlur' : '']">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'RedirectLayout',
  props: {
    needBlurBackground: {
      type: Boolean,
    },
  },
  components: {},
  data: () => ({}),
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
/*
 * Custom styles
 */
@import "@/assets/css/global.scss";
</style>
